// @ts-nocheck

export function appendAgentAccountFields(payload, { selectedACL, accountType, expiryDate }) {
  if (selectedACL !== undefined) {
    payload.acl_settings = selectedACL === '' ? null : selectedACL;
  }
  if (accountType !== undefined && accountType !== null && accountType !== '') {
    payload.account_type = Number(accountType);
  }
  if (expiryDate) {
    payload.expiry_date = expiryDate;
  }
  return payload;
}
